import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {SelectItemComponent} from "./components/select-item/select-item.component";
import {AddOrganizationComponent} from "./components/add-organization/add-organization.component";
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import {ModalWindowComponent} from "../std-components/modal-window/modal-window.component";
import {HasNotRoleDirective, HasRoleDirective} from "../shared/directives/has-role.directive";


const components = [
  SelectItemComponent,
  AddOrganizationComponent,
];

@NgModule({
  declarations: [
    ...components
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    ModalWindowComponent,
    HasRoleDirective,
    HasNotRoleDirective
  ],
  exports: [
    ...components,
    HasRoleDirective,
    HasNotRoleDirective
  ]
})
export class NewSharedModule {}
